<template>
  <div style="width: 100%;height: 100%;">
    <div style="margin-bottom:10px;width: 100%;">
      <span style="font-size: 15px;"><b>数据看板：</b></span>
      <!--   数量框   -->
      <el-row>
        <el-row class="borderData">
          <div class="fountStyle" style="">总模具</div>
          <div class="sumFountStyle" style="color: blue">{{ moldResumeList.length }}</div>
        </el-row>
        <el-row class="borderData" v-for="item in moldStatusList">
          <div class="fountStyle" style="">{{ item.name }}</div>
          <div class="sumFountStyle" :style="item.color">{{ item.cnt }}</div>
        </el-row>
      </el-row>
      <el-row style="font-size: 15px; align-items: center;margin-top: 10px">
        <b>{{ '寿命进度:' }}</b>
        <el-select v-model="moldStatus" clearable placeholder="模具状态" filterable @change="getMoldResumeByMoldStatus(moldStatus)"
                   style="width: 200px;margin-left:50px">
          <el-option v-for="item in moldStatusList" :key="item.value" :label="item.name" :value="item.value"/>
        </el-select>
      </el-row>
    </div>

    <div style="width: 100%;height: 55vh;overflow: auto">
      <div ref="progress">
        <el-row>
          <div v-for="mold in moldList" style="margin-top: 10px;width: 48%;">
            <el-row style="width: 100%;">
              <span style="font-size: 12px;text-align: right;width: 15%;"><b>{{ mold.id + '：' }}</b></span>
              <el-progress :text-inside="true" :stroke-width="15"
                           :format="(percentage) => (percentage === 100 ? mold.life_rate_former+'%' : `${percentage}%`)"
                           :percentage="mold.life_rate" :color="mold.color"
                           style="width: 80%;"/>
            </el-row>
          </div>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MoldDataBoard",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      moldList: [],
      moldResumeList: [],
      moldStatus:'',
      moldStatusList:[]

    };
  },
  computed: {},
  created() {
    //获取模具履历
    this.getMoldResumeList()
    //计算模具状态数量
    this.dealMoldStatusCnt();
  },
  mounted() {
    //根据模具状态查询
    this.getMoldResumeByMoldStatus(null);
  },
  methods: {

    async getMoldResumeList() {
      this.moldResumeList = await this.$http("mesMoldDataBoardService.getMoldResumeList",{componentParam:this.componentParam})
      await this.updateMoldResume();
    },

    //更新模具履历
    async updateMoldResume(){
      for (const moldResume of this.moldResumeList) {
        await this.$http("mesMoldResumeService.dealMoldResumeData",moldResume)
      }
    },

    //获取模具状态、数量
    async dealMoldStatusCnt(){
      this.moldStatusList = await this.$http("mesMoldDataBoardService.dealMoldStatusCnt",{componentParam:this.componentParam})
    },

    //获取模具状态
    async getMoldResumeByMoldStatus(moldStatus) {
      let params = {mold_status : moldStatus,componentParam:this.componentParam}
      this.moldList = await this.$http("mesMoldDataBoardService.getMoldResumeByMoldStatus",params)
    },
  }
}
</script>

<style scoped>

.borderData {
  border: 1px solid #A5A6A4FF;
  width: 11%;
  margin: 10px
}

.fountStyle {
  font-size: 13px;
  margin: 5px 10px;
  color: #A5A6A4FF
}

.sumFountStyle {
  width: 100%;
  text-align: center;
  margin-top: -12px;
  /*margin-left: -12px;*/
  font-size: 45px;
}

:deep(.el-progress-bar__innerText) {
  color: black;
}

</style>